import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  isRequired: yup.bool().required(),
});

export function useUpdateAppointmentRequireDobSettingMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return http.put(HTTP_ENDPOINTS.appointments.updateRequireDob(), {
        is_dob_required: req.isRequired,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.account],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
